<app-breadcrumb [links]="[{link: 'admin', name: 'Adminstração'}]" current="Funcionários"></app-breadcrumb>
<div class="backgroundColor star-dust darken-3">
	<section class="container-fluid backgroundColor star-dust darken-3 position-relative top-119 " id="my-element">
		<div class="container">
			<div class="row">
				<div class="col-6 mb-20 pt-5">
					<h1 class="text-white text-shadow">Inserir Funcionários</h1>
				</div>
				<div class="col-6 mb-20 pt-5 d-flex justify-content-between">
					<a class="font-decoration textColor shark base" href="/pass">
						<button type="button" class="px-4 py-3 btn btn-harvest-gold darken-1 duration-500">Alterar a minha Password</button>
					</a>
				</div>
			</div>
			<div class="row d-flex justify-content-around">
				<div class="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3 fixedHeight no-padd">
					<ng-container *ngFor="let item of list">
						<div class="card text-white mb-3 model-border">
							<div class="card-body">
								<div class="col-12 no-padd">
									<p>Nome: <span class="text-capitalize">{{item.nome}}</span></p>
								</div>
								<div class="col-12 no-padd">
									<p>E-mail: {{item.email}}</p>
								</div>
								<div class="col-12 d-flex my-4">
									<button class="btn harvest-gold base padd-5 mx-auto" (click)="delete(item)"><fa-icon [icon]="faTrash" class="fad fa-trash"></fa-icon></button>
									<button class="btn shark lighten-3 mx-auto" (click)="bind(item)"><fa-icon [icon]="faEdit" class="fad fa-edit"></fa-icon></button>
								</div>
							</div>
						</div>
					</ng-container>
				</div>
				<div class="col-12 col-sm-12 col-md-7 col-lg-6 backgroundColor shark base p-4" *ngIf="model.id == 0"></div>
				<div class="col-12 col-sm-12 col-md-7 col-lg-6 backgroundColor shark base p-4 text-white mb-20" *ngIf="model.id != 0">
					<div class="form-group">
						<label>Nome</label>&nbsp;
						<input class="form-control" type="text" [(ngModel)]="model.nome">
					</div>
					<div class="form-group">
						<label>E-Mail</label>&nbsp;
						<input class="form-control" type="email" [(ngModel)]="model.email" (change)="checkEmail()">
					</div>
					<div class="form-group">
						<p class="custom-form-control backgroundColor harvest-gold base"><span class="textColor black base">Por defeito a palavra passe para todos os novos funcionários é: <span class="font-weight-bold">password</span><br>No primeiro login do funcionário é solicitada a sua alteração</span></p>
					</div>
					<div class="form-group" *ngIf="error.email">
						<p class="form-control backgroundColor red base"><span class="textColor black base">O e-mail que quer registar ja-se encontra registado</span></p>
					</div>
					<button type="submit" class="btn btn-primary mr-5 duration-300" (click)="send()">Submeter</button>
					<button type="submit" class="btn btn-secondary" (click)="clear()" *ngIf="model.id != null && model.id != undefined && model.id != -1">Limpar</button>
				</div>
			</div>
		</div>
	</section>

</div>